import {HubConnectionBuilder} from '@microsoft/signalr/dist/esm/HubConnectionBuilder';
const signalR = require('@microsoft/signalr');

// class HeartBitTracker {

//     constructor(interval, marging = 1000) {
//         this._prevTimeCheck = this._getTime();
//         this._interval = interval;
//     }

//     set OnDelayDetected(delayHandler) {
//         this._hdl = delayHandler;
//     }

//     _getTime() {
//         return (new Date()).getTime();
//     }

//     _check() {
//         const fuzzyMargin = 150;
//         const now = this._getTime();
//         const diff = now - this._prevTimeCheck;
//         if (diff > this._interval + fuzzyMargin) {
//             if (this._hdl) {
//                 this._hdl();
//             }
//         }
//         this._prevTimeCheck = now;
//     }

// }

class SignalrConnection {
    constructor(hubUrl, methodsMap) {
        this._hubUrl = hubUrl;
        this._prefix = `${location.protocol}//`;
        this._methods = methodsMap;
        this._maxReconnectLimit = 10;
        this._reconnectTimeoutMs = 20000;
        this._retryDelays = [0, 20000, 40000, 60000, 80000, 100000, 120000, 140000, 160000, 180000, 200000];
        this._state = SignalrConnection.State.OFF;
        this._initWrappedConnection();
        this._resetReconnectLimit();
    }

    start(onStartHdl = null, onErrHdl = null) {
        if (!onErrHdl) {
            onErrHdl = (ex) => this._defaultErrorHandler(ex);
        }
        this._conn.start().catch(onErrHdl).then(() => {
            this._state = SignalrConnection.State.ON;
            // this._resetReconnectLimit();
            if (onStartHdl) {
                onStartHdl();
            }
        });
    }

    invoke(name, ...args) {
        const hdl = () => this._conn.invoke(name, ...args).catch((ex) => this._defaultErrorHandler(ex));
        if (this._state === SignalrConnection.State.ON) {
            hdl();
        } else {
            this._tryReconnect(true, hdl,
                (ex) => {
                    alert('Connection problems detected. Please, try to reload the page.');
                    this._defaultErrorHandler(ex);
                });
        }
    }

    _initWrappedConnection() {
        this._conn = new HubConnectionBuilder()
            .withUrl(this._hubUrl, {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
            })
            .withAutomaticReconnect(this._retryDelays)
            .build();
        this._conn.onclose(() => this._onCloseHdl());
        this._initDefaultSubscriptions();
    }

    _resetReconnectLimit() {
        this._reconnectLimit = this._maxReconnectLimit;
    }

    _onCloseHdl() {
        this._state = SignalrConnection.State.OFF;
        this._tryReconnect();
    }

    _initDefaultSubscriptions() {
        this._conn.onclose = (ex) => {
            if (ex) {
                this._defaultErrorHandler(ex, true);
            }
        };

        for (const key of Object.keys(this._methods)) {
            this._conn.on(key, this._methods[key]);
        }
    }

    _defaultErrorHandler(ex) {
        console.log(ex);
        this._conn.stop();
        this._state = SignalrConnection.State.OFF;
        this._tryReconnect();
    }

    _tryReconnect(force = false, onSuccessHdl = null, onErrorHdl = null) {
        if (this._reconnectLimit > 0 || force === true) {
            setTimeout(() => {
                try {
                    this._conn.stop();
                } catch (ex) {
                    console.log(ex);
                }
                this._initWrappedConnection();
                --this._reconnectLimit;
                this.start(onSuccessHdl, onErrorHdl);
            },
            this._reconnectTimeoutMs);
        } else {
            console.log('To many connection failures. Try to reload the page.');
        }
    }
}

SignalrConnection.State = {ON: true, OFF: false};

export {
    SignalrConnection,
};
